import React, { useState, useEffect } from "react"
import { useUsers } from './'
import {
  CheckboxSelect,
  CheckboxLabel,
  CheckboxFilterSelect,
  Image
} from '../components'
import {
  createFilterUserCheckbokLabel
} from '../generators/labelGenerator'

const useUsersFilterSelect = ({
  users,
  buildSelectUsers,
  selectedObjects,
  handleAddCoverCostUser,
  style,
  selectAll,
  hideWarning,
  callback,
  closed,
}) => {
  const [_selectObjectIds, setSelectObjectIds] = useState([])

  useEffect(() => {
    if (selectedObjects) {
      setSelectObjectIds(users.filter(u => {
        return selectedObjects.map(su => su.id).includes(u.id)
      }).map(obj => obj.id))
    } else {
      setSelectObjectIds(buildSelectUsers(users).map(obj => obj.id))
    }
  }, [users, selectedObjects])

  const handleSelectChanged = (objects) => {
    setSelectObjectIds(objects.map(obj => obj.id))
    if (callback) { callback(objects.map(obj => obj.id)) }
  }

  const select = <CheckboxFilterSelect
    buildSelectUsers={buildSelectUsers}
    handleAddCoverCostUser={handleAddCoverCostUser}
    closed={closed}
    createLabel={createFilterUserCheckbokLabel}
    selectAll={selectAll}
    objects={users}
    hideWarning={hideWarning}
    style={style}
    selected_object_ids={_selectObjectIds}
    changed={handleSelectChanged}
  />

  return [_selectObjectIds, select];
}

export default useUsersFilterSelect;

const styles = {
  label: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}
